/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SearchPatientEmarAliases {
  AUTOCOMPLETE_DEPARTMENTS = 'autocomplete-departments',
  AVATAR_EMAR = 'avatar-emar',
  BARCODE_COMPONENT = 'barcode-component',
  CONTEXTUAL_BAR = 'contextual-bar',
  FETCH_DEPARTMENTS = 'fetch-departments',
  FIELD_BARCODE = 'field-barcode',
  FIELD_DEPARTMENTS = 'field-departments',
  FILTER_PATIENTS = 'filter-patients',
  FILTERED_LIST = 'filtered-list',
  LAYOUT = 'layout',
  MAPPER_DEPARTMENTS = 'mapper-departments',
  PANEL_0 = 'panel-0',
  PANEL_RESOLUTION = 'panel-resolution',
  PATIENT_FETCH = 'patient-fetch',
  PATIENT_FETCH_AVATAR = 'patient-fetch-avatar',
  PATIENT_FETCH_CARD = 'patient-fetch-card',
  PATIENT_FETCH_DECK = 'patient-fetch-deck',
  PATIENT_FETCH_MAPPER = 'patient-fetch-mapper',
  PATIENT_FETCH_PANEL = 'patient-fetch-panel',
  TEXT_DEPARTMENTS = 'text-departments',
  TEXT_RESOLUTION_SUPORTED = 'text-resolution-suported',
}
export { SearchPatientEmarAliases };
